import "./footer.scss";

import React from "react";
import { Link, useStaticQuery, graphql } from "gatsby";

import SocialIcon from "../SocialIcon";
import SponsorsSection from "../SponsorsSection";

const Menu = ({ label, labelLink, items }) => {
   return (
      <>
         <Link to={labelLink} className="footer__menu-title">
            {label}
         </Link>
         {items && (
            <ul className="footer__menu">
               {items?.map((item, index) => {
                  return (
                     <li className="footer__menu-item" key={index}>
                        {item.link && (
                           <Link to={item.link} className="footer__menu-link">
                              {item.label}
                           </Link>
                        )}
                        {item.url && (
                           <a
                              href={item.url}
                              className="footer__menu-link"
                              rel="noreferrer noopener nofollow"
                           >
                              {item.label}
                           </a>
                        )}
                     </li>
                  );
               })}
            </ul>
         )}
      </>
   );
};

const Footer = () => {
   const query = useStaticQuery(graphql`
      {
         allWp {
            nodes {
               themeSettings {
                  acfThemeSettings {
                     fundingText
                  }
               }
            }
         }
      }
   `);

   const scrollToTop = () => {
      window[`scrollTo`]({ top: 0, behavior: `smooth` });
   };

   const themeSettings = query.allWp.nodes[0].themeSettings.acfThemeSettings;

   return (
      <>
         <SponsorsSection />
         <footer className="footer">
            <button
               type="button"
               className="footer__back-to-top"
               onClick={scrollToTop}
            >
               <img
                  src={require("assets/icons/arrow-top.svg").default}
                  alt="Strzałka do góry"
               />
            </button>
            <div className="container footer__container">
               <div className="row align-items-end">
                  <div className="col-lg-8">
                     <img
                        src={require("assets/images/logo-white.svg").default}
                        alt="Małopolska Lokalnie Logo"
                        className="img-fluid footer__logo"
                     />
                     <div className="footer__socials-container">
                        <SocialIcon
                           icon={require("assets/icons/fb-white.svg").default}
                           label="Małopolska Lokalnie"
                           link="https://www.facebook.com/malopolskalokalnie"
                        />
                        <SocialIcon
                           icon={require("assets/icons/fb-white.svg").default}
                           label="Fundacja BIS"
                           link="https://www.facebook.com/FundacjaBIS"
                        />
                        <SocialIcon
                           icon={require("assets/icons/fb-white.svg").default}
                           label="Stowarzyszenie Forum Oświatowe Klucze"
                           link="https://www.facebook.com/Stowarzyszenie-Forum-O%C5%9Bwiatowe-Klucze-460667487338331"
                        />
                        <SocialIcon
                           icon={require("assets/icons/yt-white.svg").default}
                           link="https://www.youtube.com/channel/UCnDIUE-TxRv7LhbJYJ5wYSg"
                        />
                        <SocialIcon
                           icon={require("assets/icons/ig-white.svg").default}
                           link="https://www.instagram.com/malopolskalokalnie.pl/"
                        />
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="footer__pl-container">
                        <img
                           src={
                              require("assets/images/poland-flag.png").default
                           }
                           alt="Flaga Polski"
                           className="img-fluid footer__flag"
                        />
                        <img
                           src={
                              require("assets/images/poland-logo.png").default
                           }
                           alt="Polska Logo"
                           className="img-fluid footer__pl-logo"
                        />
                     </div>
                     {themeSettings?.fundingText && (
                        <div
                           className="footer__small-text"
                           dangerouslySetInnerHTML={{
                              __html: themeSettings.fundingText,
                           }}
                        />
                     )}
                  </div>
               </div>
               <div className="footer__row footer__row--menu">
                  <div className="footer__menu-col">
                     <Menu label="Aktualności" labelLink="/aktualnosci" />
                  </div>
                  <div className="footer__menu-col">
                     <Menu
                        label="O Małopolska Lokalnie"
                        items={[
                           {
                              label: "Program w skrócie",
                              link: "/o-malopolska-lokalnie",
                           },
                           {
                              label: "Terminy konkursów",
                              link: "/terminy-konkursow",
                           },
                           {
                              label: "Trwające konkursy",
                              link: "/trwajace-konkursy",
                           },
                           // {
                           //    label: "Konkursy zakończone",
                           //    link: "/konkursy-zakonczone",
                           // },
                           {
                              label: "Operatorzy",
                              link: "/operatorzy-malopolska-lokalnie",
                           },
                           {
                              label: "Ambasadorowie",
                              link: "/ambasadorowie-fio-malopolska-lokalnie",
                           },
                        ]}
                     />
                  </div>
                  <div className="footer__menu-col">
                     <Menu
                        label="Lokalne programy grantowe"
                        items={[
                           {
                              label: "Konkursy realizowane",
                              link: "/konkursy-realizowane",
                           },
                           // {
                           //    label: "Konkursy zakończone",
                           //    link: "/konkursy-zakonczone",
                           // },
                           { label: "Oferta dla JST", link: "/oferta" },
                        ]}
                     />
                  </div>
                  <div className="footer__menu-col">
                     <Menu
                        label="Dla wniskodawców"
                        items={[
                           { label: "Dla kogo", link: "/dla-kogo" },
                           {
                              label: "Rodzaje wspieranych inicjatyw",
                              link: "/rodzaje-wspieranych-inicjatyw",
                           },
                           {
                              label: "Jak złożyć wniosek",
                              link: "/jak-zlozyc-wniosek",
                           },
                           {
                              label: "Dokumentacja projektowa",
                              link: "/dokumentacja-projektowa",
                           },
                           {
                              label: "Szkolenia i webinary",
                              link: "/szkolenia-i-webinary",
                           },
                           { label: "Kontakt do doradców", link: "/kontakt" },
                           { label: "", link: "/" },
                           { label: "", link: "/" },
                           { label: "", link: "/" },
                        ]}
                     />
                  </div>
                  <div className="footer__menu-col">
                     <Menu
                        label="Dla realizatorów"
                        items={[
                           {
                              label: "Podręcznik dla realizatorów",
                              link: "/podrecznik-dla-realizatorow",
                           },
                           {
                              label: "Materiały graficzne",
                              link: "/materialy-graficzne",
                           },
                           {
                              label: "Szkolenia i webinary",
                              link: "/szkolenia-i-webinary",
                           },
                           { label: "Kontakt do doradców", link: "/kontakt" },
                        ]}
                     />
                  </div>
                  <div className="footer__menu-col">
                     <Menu
                        label="Inspiracje"
                        labelLink="/inspiracje"
                        items={[
                           {
                              label: "Archiwum",
                              url: "http://archiwum.malopolskalokalnie.pl/index.php/plebiscyt/archiwalne.html",
                           },
                        ]}
                     />
                  </div>
                  <div className="footer__menu-col">
                     <Menu
                        label="Głosowanie w konkursie internetowym"
                        items={[
                           {
                              label: "Mapa realizowanych projektów",
                              link: "/mapa-realizowanych-projektow",
                           },
                           { label: "Głosowanie", link: "/glosowanie" },
                           {
                              label: "Wyniki głosowania",
                              link: "/glosowanie/wyniki-glosowania",
                           },
                        ]}
                     />
                  </div>
                  <div className="footer__menu-col">
                     <Menu
                        label="Kontakt"
                        items={[
                           {
                              label: "Operatorzy",
                              link: "/operatorzy-malopolska-lokalnie",
                           },
                           {
                              label: "Ambasadorowie",
                              link: "/ambasadorowie-fio-malopolska-lokalnie",
                           },
                        ]}
                     />
                  </div>
               </div>
               <div className="footer__row footer__row--copy">
                  <div className="footer__copy-text">
                     &copy; Małopolska Lokalnie {new Date().getFullYear()}
                  </div>
                  <div className="footer__copy-mid-text">
                     <Link
                        to="/polityka-cookies"
                        className="footer__copy-link footer__copy-text"
                     >
                        Polityka Cookies
                     </Link>
                     <Link
                        to="/rodo"
                        className="footer__copy-link footer__copy-text"
                     >
                        RODO
                     </Link>
                  </div>
                  <a
                     href="https://adream.pl/"
                     target="_blank"
                     rel="noreferrer nofollow"
                     className="footer__copy-author footer__copy-text"
                  >
                     Projekt i wykonanie ADream
                  </a>
               </div>
            </div>
         </footer>
      </>
   );
};

export default Footer;
